import { ArrowLeft, Plus } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { APP_COLORS } from '@/helpers/constants'

const GroupSettingHeader = ({ title, isFormPage }: { title: string; isFormPage?: boolean }) => {
  const { t } = useTranslation(['groups'])
  const navigate = useNavigate()

  return (
    <div className="groups-toolbar">
      <div className="header-buttons">
        <button
          type="submit"
          className="button button-lightgray"
          onClick={() =>
            navigate(
              isFormPage
                ? '/dashboard/building-dashboard/groups-settings'
                : '/dashboard/building-dashboard/groups/posts',
            )
          }
        >
          <ArrowLeft size={20} />
          <span>{t('groups:header.back')}</span>
        </button>
        <div className="header">{title}</div>
      </div>
      {!isFormPage && (
        <div className="header-buttons">
          <button
            type="submit"
            className="button button-primary"
            onClick={() => navigate('/dashboard/building-dashboard/groups-settings/create')}
          >
            <span>{t('groups:header.addGroup')}</span>
            <Plus color={APP_COLORS.baseWhite} size={20} />
          </button>
        </div>
      )}
    </div>
  )
}

export default GroupSettingHeader
